export function darkmodeScale() {
		// Constants
		const themeSelectors = document.querySelectorAll(".jsDarkmodeToggle");
		if (themeSelectors.length == 0) {
			return;
		}
		const storageKey = "colorThemeDarkMode";
		const lightThemeClass = "light-theme";
		const darkThemeClass = "dark-theme";
		const isDarkSystemTheme =
			window.matchMedia &&
			window.matchMedia("(prefers-color-scheme: dark)").matches;

		const navbrandImg = jQuery(
			".header__megamenu-extended .navbar__megamenu-extended .navbar__megamenu__header .navbar-brand img",
		);
		const footerbrandImg = jQuery("footer .logo img[data-defaultLogo]");
		const footerSubbrandImg = jQuery("footer .logo img[data-defaultSubLogo]");
		const favicon = jQuery("link[rel='icon']");
		// Get the theme preference (dark-theme, light-theme, or null)
		const getSelectedTheme = () => localStorage.getItem(storageKey);

		// Set theme helper
		const setSelectedTheme = (theme) => localStorage.setItem(storageKey, theme);

		// Functions to add/remove dark/light theme classes
		const applyDarkModeClasses = () => {
			document.documentElement.classList.add(darkThemeClass);
			document.documentElement.classList.remove(lightThemeClass);
			setDarkmodeLogo();
			document.dispatchEvent(new CustomEvent("cabana:darkmode-changed"));
		};

		const applyLightModeClasses = () => {
			document.documentElement.classList.add(lightThemeClass);
			document.documentElement.classList.remove(darkThemeClass);
			setDefaultLogo();
			document.dispatchEvent(new CustomEvent("cabana:darkmode-changed"));
		};

		// Handle theme toggle
		const handleThemeToggle = () => {
			const isDarkModeActive = document.documentElement.classList.toggle(darkThemeClass);

			if (isDarkModeActive) {
				applyDarkModeClasses();
				setSelectedTheme(darkThemeClass);
			} else {
				applyLightModeClasses();
				setSelectedTheme(lightThemeClass);
			}

			updateToggleState(isDarkModeActive);
		};

		const updateToggleState = (isDarkModeActive) => {
			themeSelectors.forEach((item) => {
				item.classList.toggle("active", isDarkModeActive);
				const label = isDarkModeActive
					? item.getAttribute("data-active")
					: item.getAttribute("data-inactive");
				// Only the tooltip says what a click does; the accessible name stays fixed and aria-pressed carries the state
				if (label) {
					item.setAttribute("title", label);
				}
				item.setAttribute("aria-pressed", isDarkModeActive ? "true" : "false");
			});
		};

		// Initialize the theme on mount
		const initializeTheme = () => {
			const selectedTheme = getSelectedTheme();
			if (selectedTheme === darkThemeClass) {
				applyDarkModeClasses();
				updateToggleState(true);
			} else {
				applyLightModeClasses();
				updateToggleState(false);
			}

			// Set favicon based on system dark mode preference
			setFaviconBasedOnSystemTheme();
		};

		// Set logos and favicon for dark mode
		function setDarkmodeLogo() {
			const darkmodeNavLogo = navbrandImg.attr("data-darkmodeLogo");
			navbrandImg.attr("src", darkmodeNavLogo);

			const darkmodeFooterLogo = footerbrandImg.attr("data-darkmodeLogo");
			footerbrandImg.attr("src", darkmodeFooterLogo);

			const darkmodeSubFooterLogo = footerSubbrandImg.attr(
				"data-darkmodeSubLogo",
			);
			footerSubbrandImg.attr("src", darkmodeSubFooterLogo);
		}

		// Set logos and favicon for light mode (default)
		function setDefaultLogo() {
			const defaultNavLogo = navbrandImg.attr("data-defaultLogo");
			navbrandImg.attr("src", defaultNavLogo);

			const defaultFooterLogo = footerbrandImg.attr("data-defaultLogo");
			footerbrandImg.attr("src", defaultFooterLogo);

			const subFooterLogo = footerSubbrandImg.attr("data-defaultSubLogo");
			footerSubbrandImg.attr("src", subFooterLogo);
		}

		// Set favicon based on system theme preference
		function setFaviconBasedOnSystemTheme() {
			if (isDarkSystemTheme) {
				const darkmodeFavicon = favicon.attr("data-darkmode");
				favicon.attr("href", darkmodeFavicon);
			} else {
				const defaultFavicon = favicon.attr("data-default");
				favicon.attr("href", defaultFavicon);
			}
		}

		// Event listener setup
		themeSelectors.forEach((button) => {
			button.addEventListener("click", handleThemeToggle);
		});

		initializeTheme();
	// Initialize on page load
}

export default darkmodeScale;
